import { NgModule } from '@angular/core';
import { CodeMirrorComponent } from './code-mirror/code-mirror.component';


@NgModule({
  imports: [CodeMirrorComponent],
  exports: [CodeMirrorComponent],
  providers:[]
})
export class CodeMirrorModule {}
